/**
 * @fileoverview gRPC-Web generated client stub for trade
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.3
// source: src/grpc/trade.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.trade = require('./trade_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trade.TradeClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trade.TradePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trade.TradeRequest,
 *   !proto.trade.TradeResponse>}
 */
const methodDescriptor_Trade_SendOrder = new grpc.web.MethodDescriptor(
  '/trade.Trade/SendOrder',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.trade.TradeRequest,
  proto.trade.TradeResponse,
  /**
   * @param {!proto.trade.TradeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeResponse.deserializeBinary
);


/**
 * @param {!proto.trade.TradeRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.sendOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/SendOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_SendOrder);
};


/**
 * @param {!proto.trade.TradeRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.sendOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/SendOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_SendOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trade.TradeEditRequest,
 *   !proto.trade.TradeResponse>}
 */
const methodDescriptor_Trade_EditPosition = new grpc.web.MethodDescriptor(
  '/trade.Trade/EditPosition',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.trade.TradeEditRequest,
  proto.trade.TradeResponse,
  /**
   * @param {!proto.trade.TradeEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeResponse.deserializeBinary
);


/**
 * @param {!proto.trade.TradeEditRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.editPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/EditPosition',
      request,
      metadata || {},
      methodDescriptor_Trade_EditPosition);
};


/**
 * @param {!proto.trade.TradeEditRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.editPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/EditPosition',
      request,
      metadata || {},
      methodDescriptor_Trade_EditPosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trade.TradeEditRequest,
 *   !proto.trade.TradeResponse>}
 */
const methodDescriptor_Trade_EditOrder = new grpc.web.MethodDescriptor(
  '/trade.Trade/EditOrder',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.trade.TradeEditRequest,
  proto.trade.TradeResponse,
  /**
   * @param {!proto.trade.TradeEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeResponse.deserializeBinary
);


/**
 * @param {!proto.trade.TradeEditRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.editOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/EditOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_EditOrder);
};


/**
 * @param {!proto.trade.TradeEditRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.editOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/EditOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_EditOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trade.TradeCloseRequest,
 *   !proto.trade.TradeResponse>}
 */
const methodDescriptor_Trade_ClosePosition = new grpc.web.MethodDescriptor(
  '/trade.Trade/ClosePosition',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.trade.TradeCloseRequest,
  proto.trade.TradeResponse,
  /**
   * @param {!proto.trade.TradeCloseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeResponse.deserializeBinary
);


/**
 * @param {!proto.trade.TradeCloseRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.closePosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/ClosePosition',
      request,
      metadata || {},
      methodDescriptor_Trade_ClosePosition);
};


/**
 * @param {!proto.trade.TradeCloseRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.closePosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/ClosePosition',
      request,
      metadata || {},
      methodDescriptor_Trade_ClosePosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trade.TradeCloseRequest,
 *   !proto.trade.TradeResponse>}
 */
const methodDescriptor_Trade_DeleteOrder = new grpc.web.MethodDescriptor(
  '/trade.Trade/DeleteOrder',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.trade.TradeCloseRequest,
  proto.trade.TradeResponse,
  /**
   * @param {!proto.trade.TradeCloseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeResponse.deserializeBinary
);


/**
 * @param {!proto.trade.TradeCloseRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.deleteOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/DeleteOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_DeleteOrder);
};


/**
 * @param {!proto.trade.TradeCloseRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeResponse>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.deleteOrder =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/DeleteOrder',
      request,
      metadata || {},
      methodDescriptor_Trade_DeleteOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trade.TradeEvent>}
 */
const methodDescriptor_Trade_Subscribe = new grpc.web.MethodDescriptor(
  '/trade.Trade/Subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  proto.trade.TradeEvent,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trade.TradeEvent.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeEvent>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradeClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/Subscribe',
      request,
      metadata || {},
      methodDescriptor_Trade_Subscribe);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.trade.TradeEvent>}
 *     The XHR Node Readable Stream
 */
proto.trade.TradePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/trade.Trade/Subscribe',
      request,
      metadata || {},
      methodDescriptor_Trade_Subscribe);
};


module.exports = proto.trade;

